<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">基础管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">销售合同基础利率</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">
        <div class="layout-content-main">
          <div class="method-wrapper">
            <div style="display:inline-block;">
             <template>
                <Input v-model="searchResult"  placeholder="利率类型" style="width: 300px"></Input>
             </template>
             <Button type="ghost" class="mRight mLeft" @click="this.getResearch">查询</Button>
            </div>
            <Button  type="primary" class="mRight" @click="this.addContract">新增</Button>
            <Button  type="primary" class="mRight" @click="this.editContract">修改</Button>
            <Button  type="primary" class="mRight" @click="this.deleteData" >删除</Button>
          </div>
          <div class="clearfix"></div>
          <div class="table-wrapper">
             <area-com ></area-com>
             <Table 
                :loading="loading"
                :columns="columns"
                :data="listData.data"
                @on-selection-change="getSelected"
            >
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="listData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!--------弹层-------------->
    <Modal 
    v-model="addModal"
    :mask-closable="false"
    >
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{modelName}}</span>
        </p>
        <Form ref="addItem" :model="addItem" :label-width="100" :rules="ruleValidate">
            <FormItem label="组织机构名称" prop="name">
                <Button type="default" long style="text-align:left;" @click=" modalDept = true">{{ treeNode }} </Button>
            </FormItem>
            <FormItem label="利率类型" prop="type">
                <Select v-model="addItem.select" placeholder="请选择利率类型">
                    <Option :value="v.code" v-for="(v,index) in rateType" :key="index">{{v.value}}</Option>
                    
                </Select>
            </FormItem>
            <FormItem label="利率描述" prop="desc">
                <Input v-model="addItem.desc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入利率描述"></Input>
            </FormItem>
            <FormItem label="维护值" prop="rateValue">
                <Input v-model="addItem.maintain" type="text"  placeholder="请输入维护值"></Input>
            </FormItem>
        </Form>
        <div slot="footer">
         <Button type="primary" @click="submitData('addItem')" long >确定</Button>
        </div>
    </Modal>
    <!-- 选择组织机构 -->
    <Modal
            v-model="modalDept"
            :mask-closable="false">
            <p slot="header" style="text-align:center">
                <Icon type="information-circled"></Icon>
                <span>选择机构</span>
            </p>
            <div style="text-align:center">
                <tree-com 
                :deptData="deptLists"
                :addNews = "addNews"
                :selectedId = "dePtNodeSelect" 
                v-on:getTreeOne = 'getDeptNodes'
                >
                </tree-com> 
            </div>
            <div slot="footer">
                <Button type="primary"  long  @click="closeDeptModal()" >确定</Button>
            </div>
    </Modal>
  </div>
</template>
<style  lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }

  
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  import treeCom from '../../components/treeOne' 
  import TreeGrid from '../../components/TreeGrid'
  import areaCom from '../../components/areaCom'
  
  
  export default{
    data(){
      const validaType = (rule, value, callback) =>{
            if(value == ''){
                callback(new Error('请选择利率类型！'));
            }
            // 模拟异步验证效果
                setTimeout(() => {
                    if (value == '') {
                        callback(new Error('利率类型不能为空'));
                    } else {
                        callback();
                    }
                }, 100);
        };  
        const validaName = (rule, value, callback) =>{
            if(value == ''){
                callback(new Error('请选择组织架构！'));
            }
            // 模拟异步验证效果
                setTimeout(() => {
                    if (value == '') {
                        callback(new Error('组织架构不能为空'));
                    } else {
                        callback();
                    }
                }, 100);
        };
        const validaNum = (rule, value, callback) =>{
            if(value == ''){
                callback(new Error('请输入维护值！'));
            }
            // 模拟异步验证效果
                setTimeout(() => {
                    if (value == '') {
                        callback(new Error('维护值不能为空'));
                    } else {
                        callback();
                    }
                }, 100);
        };
      return {
       loading:true,
       modelName:'',
       addNews:[],
        columns: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: '组织机构名称',
                key:'segNo',
                width: 140,
                align: 'center',

            },
          
            {
                title: '利率类型', 
                key: 'accrualCode',
                align: 'center',
               
            },
            {
                title: '利率描述',
                key: 'accrualDesc',
                align: 'center'
            },
            {
                title: '维护值(单位%)',
                key: 'accrualValue',
                align: 'center'
            },
            {
                title:'修改人',
                key:'modiPerson',
                align:'center'
            },
            {
                title:'修改日期',
                key:'modiDate',
                align:'center'
            }
        ],
        addModal: false,
        modalDept:false,
        listData:{
            data:[],
             page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0
           }  
        },
        addItem:{
            name:'',
            select:'',
            desc:'',
            maintain:'',
            author:''
        },
        treeNode:'请选择组织机构名称',
        treeNodeId:'',
        deptLists:[],
        dePtNodeSelect:[],
        selectedData:[],
        ruleValidate:{
            name:[
                {required:true,validator:validaName,trigger:'change'}
            ],
            type:[
                {required:true,validator:validaType,trigger:'change'}
            ],
            desc:[
                {required:true,message:'利率描述不能为空！',trigger:'blur'}
            ],
            rateValue:[
                {required:true,validator:validaNum,trigger:'blur'}
            ]
        },
        searchResult:'',
        rateType:[],
        type:'accrualType'
      }
    },
    mounted:function(){  
        //页面加载完成以后执行
            //进入页面loading状态
         if(this.listData.data !== 0){
            this.loading = false;
        }else{
            this.loading = true;
          }
        //挂载页面执行请求列表数据
        this.getListdata(this.listData.page.pageCurrent,this.listData.page.pagesize);
        this.getRate(this.type);
        this.getOrag();
    },
    methods: {
       //获取列表数据
       getListdata:function(pageCurrent,pagesize){
           api.contract.getList({
               'page':pageCurrent,
               'limit':pagesize,
           } ,response =>{
            console.log(response);
            if(response.msg=='success'){
                this.listData.data = response.page.list;
                this.listData.page.totalCount = response.page.totalCount;
            }
        })
       },
       //搜索列表
       getResearch:function(){
               api.contract.getList({
                    page:this.listData.page.pageCurrent,
                    limit:this.listData.page.pagesize,
                    accrualCode:this.searchResult,
                }, resp => {
                    if(resp.code == 0){
                        this.listData.data = resp.page.list;
                        this.listData.page.totalCount = resp.page.totalCount;
                    }
                   
                }, error => {
                  this.$Message.error(resp.msg);
                })

            

        },
       //选中列表数据
       getSelected:function(ele){
           console.log('选中了一个')
           console.log(ele)
           this.selectedData = ele;
       },
       addContract:function(){
           this.modelName = '新增合同';
           this.addItem = {};//初始化新增
           this.addNews= '新增';
           this.addModal = true ;
           
       },
       editContract:function(){
           if(this.selectedData.length == 0){
               this.$Message.error('请选择一条记录!');
               return;
           }else if(this.selectedData.length >1){
                this.$Message.error('只能选择一条数据进行修改');
               return;
           }else{
               this.modelName = '修改合同';
               this.addNews= '';
               this.addModal = true ;
               this.addItem = {
                    name :  this.selectedData[0].segNo,
                  select :  this.selectedData[0].accrualCode,
                    desc :  this.selectedData[0].accrualDesc,
                  maintain : this.selectedData[0].accrualValue
               };
            
            
           }       
       },
       editData:function(){
           api.contract.editContract({
               id:this.selectedData[0].id,
                segNo:this.addItem.name,
                accrualCode:this.addItem.select,
                accrualDesc:this.addItem.desc,
                accrualValue:this.addItem.maintain
            },res =>{
                //console.log(res)
                if(res.code == 0){
                    this.$Message.success('修改成功');
                    this.addModal = false; 
                    this.getListdata(this.listData.page.pageCurrent,this.listData.page.pagesize);//获取列表
                }else{
                    this.$Message.error(res.msg); 
                }
            });
       },
       //获得组织架构所有组织
       getOrag:function(){
           api.Dept.treeList(
            {} ,response =>{
                console.log(response);
                this.deptLists = response.deptList;
            }
           )
        
       },
        //获得选中机构
        getDeptNodes:function(tree){
            if(tree.name){this.treeNode = tree.name;}
            if(tree.title){this.treeNode = tree.title;}
            
            this.treeNodeId = tree.deptId;
        },
        closeDeptModal:function(){
            console.log(this.treeNode)
            if(this.treeNode == '请选择组织机构名称'){
              this.$Message.error('请选择组织机构名称!');
            }else{
              this.modalDept = false;
              //this.formValidate.father = this.treeNode;
            }
        },
        submitData:function(name){
         this.$refs[name].validate((valid) =>{
             console.log(valid)
            valid = true;
            if(valid){
                 if( this.modelName == '新增合同'){
                    
                        api.contract.addContract({
                            segNo:this.treeNode,
                            accrualCode:this.addItem.select,
                            accrualDesc:this.addItem.desc,
                            accrualValue:this.addItem.maintain
                        },response=>{
                            console.log(response)
                            if(response.msg =='success'){
                            this.$Message.success('新增成功!'); 
                            this.addModal = false; 
                            this.getListdata(this.listData.page.pageCurrent,this.listData.page.pagesize);
                            }else{
                            this.$Message.error(response.msg); 
                            return; 
                            }
                        })
                        console.log(this.treeNode);
                }else if(this.modelName == '修改合同'){
                    this.editData();   
                }
            }else{
                    this.$Message.error('Fail!');
                }
            });
        },
        //删除
        deleteData:function(){
            var ids =[];
            if(this.selectedData.length == 0 || this.selectedData.length == undefined){
                this.$Message.error('请至少选择一条记录!');
                return;
            }else{
                console.log(this.selectedData);
                for(var i=0 ;i < this.selectedData.length; i++){
                  ids.push(this.selectedData[i].id);
                }
                this.del(ids);
            } 
        },
        del:function(ids){
            console.log(ids)
            api.contract.delContract(ids,response=>{
              if(response.msg == 'success'){
                this.$Message.success('删除成功!'); 
                this.getListdata(this.listData.page.pageCurrent,this.listData.page.pagesize);
              }else{
                this.$Message.error('删除失败!'); 
              }
            })
        },
         // 分页 -- 页数改变
        onChange:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.listData.page.pageCurrent = curpage;
            this.getListdata(this.listData.page.pageCurrent,this.listData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.listData.page.pagesize = size;
          this.getListdata(this.listData.page.pageCurrent,this.listData.page.pagesize);
        } ,
        //获取利率类型
        getRate:function(param){
           api.contract.rateType(param,res=>{
               if(res.code == 0){
                   this.rateType = res.typeList;
               }
           }); 
        }
    },
    components: {treeCom,TreeGrid,areaCom}
    }
</script>



// WEBPACK FOOTER //
// area.vue?6780a518